import mapValues from "lodash.mapvalues";
import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import { requiredOptionMessage } from "../../../../../utilities/validationMessages";
import {
  cityValidator,
  emailValidator,
  nameSurnameValidatorRequired,
  phoneValidatorRequired,
  postalCodePolandValidator,
  radioValidator,
  streetHouseNumberValidator,
  streetValidator,
} from "../../../../../utilities/validators";

import { ComponentId } from "./enums";

const multiPersonValidator = {
  persons: yup.lazy((obj) =>
    yup.object(
      mapValues(obj, (_, key) =>
        yup.object({
          name: nameSurnameValidatorRequired,
          surname: nameSurnameValidatorRequired,
          phone: phoneValidatorRequired(`otherPersonspersons${key}phone`),
          role: radioValidator,
          email: emailValidator,
          street: streetValidator,
          street2: streetHouseNumberValidator,
          zipCode: postalCodePolandValidator,
          city: cityValidator,
        })
      )
    )
  ),
};

export const validator = {
  [FormId.INCIDENT_OTHER_PERSONS]: yup.object({
    [ComponentId.ARE_OTHER_PEOPLE_INVOLVED]: yup
      .string()
      .required(requiredOptionMessage),
    ...multiPersonValidator,
  }),
};
